import { Button } from "@src/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@src/shared/components/ui/dialog";

export interface LeaveRecordingDialogProps {
  open: boolean;
  onKeepRecording: () => void;
  onFinishVisit: () => void;
}

/**
 * Leave guard when a visit recording is live in patient chrome.
 */
export function LeaveRecordingDialog({
  open,
  onKeepRecording,
  onFinishVisit,
}: LeaveRecordingDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onKeepRecording();
      }}
    >
      <DialogContent className="max-w-md bg-background text-foreground">
        <DialogHeader>
          <DialogTitle className="text-foreground">
            Leave while recording?
          </DialogTitle>
          <DialogDescription>
            A visit is still in progress. Keep recording to stay on this
            patient, or finish the visit to generate the note.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm-stitch:gap-0">
          <Button type="button" variant="outline" onClick={onKeepRecording}>
            Keep recording
          </Button>
          <Button type="button" onClick={onFinishVisit}>
            Finish visit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
